const OptGroup = () => null;
OptGroup.isSelectOptGroup = true;
OptGroup.displayName = 'OkkiSelectOptGroup';
export default OptGroup;
